"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface LeaseLiabilityClassicSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

export default function LeaseLiabilityClassicSubstantive({ onBack, setActiveSection }: LeaseLiabilityClassicSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName="Lease Liability"
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
